// API client for Product Performance Deep Dive.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/product-performance`;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export class ReportUnavailableError extends Error {
  constructor(message) { super(message); this.reportUnavailable = true; }
}

export class NotConnectedError extends Error {
  constructor(message) { super(message); this.notConnected = true; }
}

const call = async (url, options = {}) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (res.status === 409 && data.error === 'report_unavailable') {
    throw new ReportUnavailableError(data.message);
  }
  if (res.status === 400 && data.error === 'amazon_not_connected') {
    throw new NotConnectedError(data.message);
  }
  if (!res.ok) throw new Error(data.message || `Request failed (${res.status})`);
  return data;
};

// SF3 — account-level funnel. Built on daily traffic, so it honours the window.
export const getFunnel = (token, { start, end } = {}) => {
  const params = new URLSearchParams();
  if (start) params.set('start', start);
  if (end) params.set('end', end);
  const query = params.toString();
  return call(`${BASE}/funnel${query ? `?${query}` : ''}`, { headers: authHeaders(token) });
};

// SF1 + SF2 — the product table.
//
// The window drives the velocity columns. It cannot drive sessions or
// conversion: Amazon publishes per-ASIN traffic only aggregated over the
// report's coverage window, and the response says which window that is.
export const getProducts = (token, { start, end } = {}) => {
  const params = new URLSearchParams();
  if (start) params.set('start', start);
  if (end) params.set('end', end);
  const query = params.toString();
  return call(`${BASE}/products${query ? `?${query}` : ''}`, {
    headers: authHeaders(token),
  });
};

// SF2 — the conversion trend. Account-level and daily, so it honours the window.
export const getConversionTrend = (token, { start, end } = {}) => {
  const params = new URLSearchParams();
  if (start) params.set('start', start);
  if (end) params.set('end', end);
  const query = params.toString();
  return call(`${BASE}/conversion${query ? `?${query}` : ''}`, {
    headers: authHeaders(token),
  });
};
